import { useState } from 'react';

const GallerySection = () => {
  const [selectedCategory, setSelectedCategory] = useState('tous');

  const categories = [
    { id: 'tous', name: 'Tous' },
    { id: 'vehicules', name: 'Véhicules' },
    { id: 'destinations', name: 'Destinations' },
    { id: 'experiences', name: 'Expériences' }
  ];

  const galleryItems = [
    {
      id: 1,
      title: 'Flotte Premium',
      description: 'Véhicules de luxe entretenus avec soin',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/bb3e3b44af74c0658bd88a28c3ebfc4c.jpeg',
      category: 'vehicules'
    },
    {
      id: 2,
      title: 'Désert de Merzouga',
      description: 'Excursion magique dans les dunes du Sahara',
      image: 'https://readdy.ai/api/search-image?query=Spectacular%20Sahara%20desert%20landscape%20at%20Merzouga%20with%20golden%20sand%20dunes%2C%20camel%20caravan%20silhouettes%2C%20dramatic%20sunset%20lighting%2C%20Moroccan%20desert%20tourism%2C%20breathtaking%20natural%20scenery%2C%20warm%20golden%20hour%20photography&width=400&height=300&seq=merzouga-desert&orientation=landscape',
      category: 'destinations'
    },
    {
      id: 3,
      title: 'Clients Satisfaits',
      description: 'Moments de bonheur partagés avec nos voyageurs',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/75ccf65e25d5d2f4976f323d1658b4c2.jpeg',
      category: 'clients'
    },
    {
      id: 4,
      title: 'Ouarzazate',
      description: 'La porte du désert marocain',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/70f6fcabe5de7c0ae64c9f577902c66f.jpeg',
      category: 'destinations'
    },
    {
      id: 5,
      title: 'SUV Premium',
      description: 'Confort et sécurité pour tous terrains',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/f13bac17c94bafa59589ffa684286c50.jpeg',
      category: 'vehicules'
    },
    {
      id: 6,
      title: 'Service Personnalisé',
      description: 'Attention aux détails pour chaque client',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/44f26c433bcd2790d596d2f9566efd8e.jpeg',
      category: 'services'
    },
    {
      id: 7,
      title: 'Marrakech',
      description: 'La ville rouge et ses merveilles',
      image: 'https://readdy.ai/api/search-image?query=Iconic%20Marrakech%20cityscape%20with%20traditional%20red%20buildings%2C%20Koutoubia%20mosque%20minaret%2C%20bustling%20medina%20atmosphere%2C%20authentic%20Moroccan%20urban%20architecture%20and%20warm%20terracotta%20colors%2C%20cultural%20heritage%20site&width=400&height=300&seq=marrakech-city&orientation=landscape',
      category: 'destinations'
    },
    {
      id: 8,
      title: 'Berlines de Luxe',
      description: 'Élégance et raffinement pour vos déplacements',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/3e58d9655574f4f28d9083789ad94a25.jpeg',
      category: 'vehicules'
    },
    {
      id: 9,
      title: 'Campement Traditionnel',
      description: 'Expérience authentique dans le désert marocain',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/c4e79d2f106f36c4640563d64ba3d58e.jpeg',
      category: 'destinations'
    },
    {
      id: 10,
      title: 'Paysages Marocains',
      description: 'Découverte des merveilles naturelles du Maroc',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/11082c814f43ada06133b084e1c6a1fb.jpeg',
      category: 'destinations'
    },
    {
      id: 11,
      title: 'Médina Traditionnelle',
      description: 'Exploration des souks et ruelles historiques',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/b448a3c6639ce844fff926f78d7ba0eb.jpeg',
      category: 'destinations'
    },
    {
      id: 12,
      title: 'Chèvres dans l\'Arganier',
      description: 'Découverte des traditions rurales marocaines',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/9e5ba6603c06fd9f99cc12570753fe86.jpeg',
      category: 'destinations'
    },
    {
      id: 13,
      title: 'Architecture Historique',
      description: 'Patrimoine architectural exceptionnel du Maroc',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/2c6664f5a0468d86458876ed48a776a1.jpeg',
      category: 'destinations'
    },
    {
      id: 14,
      title: 'Kasbah Authentique',
      description: 'Découverte des forteresses historiques du Maroc',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/d8f7545e89ef0563b99f1d735134b0b0.jpeg',
      category: 'destinations'
    },
    {
      id: 15,
      title: 'Expérience Culturelle',
      description: 'Immersion dans la culture marocaine authentique',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/a3ef51ec4c234d054ed55250c74d0c56.jpeg',
      category: 'destinations'
    },
    {
      id: 16,
      title: 'Remparts Historiques',
      description: 'Découverte des fortifications anciennes du Maroc',
      image: 'https://static.readdy.ai/image/8931344a60623e87809396a0c32aa0c7/b20cbd65f13d1437621182a5ec918766.jpeg',
      category: 'destinations'
    }
  ];

  const filteredItems = selectedCategory === 'tous' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === selectedCategory);

  return (
    <section id="galerie" className="py-12 sm:py-16 md:py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-charcoal-800 mb-4 sm:mb-6">
            Galerie d'Expériences
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-charcoal-600 max-w-3xl mx-auto leading-relaxed px-4">
            Découvrez en images nos véhicules premium, les destinations exceptionnelles 
            et les moments de bonheur partagés avec nos clients.
          </p>
        </div>

        {/* Filtres */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 mb-8 sm:mb-10 md:mb-12 px-2">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                selectedCategory === category.id
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-white text-charcoal-600 hover:bg-blue-100 hover:text-blue-600'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Grille de galerie */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
          {filteredItems.map((item) => (
            <div 
              key={item.id}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="aspect-w-4 aspect-h-3 relative overflow-hidden">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 sm:h-56 md:h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <h3 className="font-semibold text-sm sm:text-base md:text-lg mb-1">{item.title}</h3>
                <p className="text-xs sm:text-sm text-gray-200">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
